// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab__headers{display:grid;row-gap:1rem;margin-bottom:2.5rem}", "",{"version":3,"sources":["webpack://./blocks/tabs/app/styles.scss"],"names":[],"mappings":"AAAA,cACE,YAAA,CACA,YAAA,CACA,oBAAA","sourcesContent":[".tab__headers {\n  display: grid;\n  row-gap: 1rem;\n  margin-bottom: 2.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
